import { BrowserIcons, PlatformIcons } from './PlatformBrowserIcons';
import { buildParameterRows } from './utils';
import type { GameParametersProps, ParameterValueProps } from './types';

import styles from './GameParameters.module.css';

function ParameterValue({ row }: ParameterValueProps) {
    if (row.kind === 'platforms') {
        return <PlatformIcons values={row.values} />;
    }

    if (row.kind === 'browsers') {
        return <BrowserIcons values={row.values} />;
    }

    return row.value;
}

export function GameParameters({ parameters, gameLanguage = null }: GameParametersProps) {
    const rows = buildParameterRows(parameters, gameLanguage);

    if (!rows.length) {
        return null;
    }

    return (
        <div className={styles.list}>
            {rows.map((row) => (
                <div key={row.label} className={styles.row}>
                    <span className={styles.label}>{row.label}</span>
                    <span className={styles.value}>
                        <ParameterValue row={row} />
                    </span>
                </div>
            ))}
        </div>
    );
}
